
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 6A1.5 1.5 0 0012 4.5H7l-1.44-3H2A1.5 1.5 0 00.5 3v8A1.5 1.5 0 002 12.5h10a1.5 1.5 0 001.5-1.5V6z","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    